import React, { useState } from "react";
import CommonSearchableDropdownInput from "../../common/inputs/CommonSearchableDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { formatMoney } from "../../../features/utils/formatMoney";
import { getCurrencySymbol } from "../../../features/utils/countires";

function CreateInvoiceServicesSection({
  order,
  data,
  setData,
  services,
  setServiceModal,
}) {
  return (
    <div className="w-full flex flex-col">
      {!order ? (
        <div className="w-full gap-1 flex mt-3 flex-col">
          <CommonSearchableDropdownInput
            label="Add service"
            placeholder="Search for service"
            // value={data?.service}
            value={""}
            options={services
              ?.filter(
                (service) =>
                  !Boolean(
                    data?.services?.find((svc) => svc?.service === service?._id)
                  )
              )
              ?.filter((service) => {
                let selectedService = data?.services?.at(0);
                let selectedServiceCurrency = services?.find(
                  (serv) => serv?._id === selectedService
                )?.currency;
                if (selectedServiceCurrency) {
                  if (service?.currency === selectedServiceCurrency)
                    return true;
                  return false;
                }
                return true;
              })
              ?.map((service) => {
                return {
                  label: service?.title,
                  value: service?._id,
                };
              })}
            optionObject
            searchDefault={""}
            onChange={(val) => {
              let serviceItems = data?.services;
              if (
                !Boolean(
                  serviceItems?.find((service) => service?.service === val)
                )
              ) {
                let service = services?.find((serv) => serv?._id === val);

                serviceItems = [
                  ...serviceItems,
                  {
                    service: val,
                    quantity: 1,
                    unitPrice: service?.defaultUnitPrice || 0,
                    currency: service?.defaultCurrency || "NGN",
                  },
                ];
              }
              setData({
                ...data,
                services: serviceItems,
              });
            }}
          />
          {data?.services?.length ? (
            <div className="w-full flex flex-wrap gap-2 mt-2">
              {data?.services?.map((item, serviceIndex) => {
                let service = services?.find(
                  (serv) => serv?._id === item?.service
                );
                const handleRemove = () => {
                  let registeredServices = data?.services;
                  registeredServices = registeredServices?.filter(
                    (registeredService) => registeredService !== item
                  );
                  setData({
                    ...data,
                    services: registeredServices,
                  });
                };
                return (
                  <div
                    className="bg-gray-100 items-center gap-2 rounded-md p-2 px-3 w-full flex flex-col"
                    key={serviceIndex}
                  >
                    <div className="flex justify-between w-full items-center gap-2">
                      <span className="text-sm flex flex-1">
                        {service?.title}
                      </span>
                      <button onClick={() => handleRemove()} className="">
                        <img
                          src="/IconClose4.svg"
                          alt=""
                          className="w-4 object-contain"
                        />
                      </button>
                    </div>
                    <div className="flex w-full justify-between gap-10">
                      <CommonFreeTextInput
                        label="Unit price"
                        value={formatMoney(
                          item?.unitPrice,
                          getCurrencySymbol(item.currency)
                        )}
                        onChange={(value) => {
                          const digitsOnly = value.replace(/\D/g, "");
                          const services = data?.services?.map((it, itIndex) =>
                            itIndex === serviceIndex
                              ? { ...it, unitPrice: Number(digitsOnly) }
                              : it
                          );
                          setData({
                            ...data,
                            services,
                          });
                        }}
                      />
                      <div className="flex flex-col">
                        <span className={`block text-sm mb-1 text-gray-600`}>
                          Quantity
                        </span>
                        <div className="flex items-center gap-2 h-12">
                          <button
                            className={`w-12 h-10 flex items-center justify-center border rounded-md text-xl ${
                              item?.quantity > 1 ? "bg-white" : ""
                            }`}
                            disabled={!(item?.quantity > 1)}
                            onClick={() => {
                              const services = data?.services?.map(
                                (it, itIndex) =>
                                  itIndex === serviceIndex
                                    ? { ...it, quantity: it?.quantity - 1 }
                                    : it
                              );
                              setData({
                                ...data,
                                services,
                              });
                            }}
                          >
                            <span className="pb-1">-</span>
                          </button>
                          <span className="w-10 text-center">
                            {item?.quantity}
                          </span>
                          <button
                            className="w-12 h-10 flex items-center justify-center border rounded-md text-xl bg-white"
                            onClick={() => {
                              const services = data?.services?.map(
                                (it, itIndex) =>
                                  itIndex === serviceIndex
                                    ? { ...it, quantity: it?.quantity + 1 }
                                    : it
                              );
                              setData({
                                ...data,
                                services,
                              });
                            }}
                          >
                            <span className="pb-1">+</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <></>
          )}
          <button
            className="text-primary1 font-bold text-sm my-1 text-left"
            onClick={() => {
              setServiceModal(true);
            }}
          >
            + Create new
          </button>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default CreateInvoiceServicesSection;
